module.exports = __webpack_public_path__ + "img/default-logo.c5ed9231.png";